import { render, staticRenderFns } from "./QuestionnaireReportPreviewPage.vue?vue&type=template&id=00737094&scoped=true&"
import script from "./QuestionnaireReportPreviewPage.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireReportPreviewPage.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireReportPreviewPage.vue?vue&type=style&index=0&id=00737094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00737094",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VIcon,VRow,VSpacer})
